import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

/** Catches render crashes so users never see a blank white page. */
export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error('UI crash:', error, info?.componentStack); }
  componentDidUpdate(prev) { if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null }); }
  render() {
    if (!this.state.error) return this.props.children;
    const { title = 'Terjadi kesalahan saat menampilkan halaman', hint = 'Data mungkin tidak lengkap. Muat ulang halaman atau kembali ke daftar website.', onRetry, backHref = '/website' } = this.props;
    return (
      <div className="flex min-h-[60vh] items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md rounded-2xl border border-border bg-white p-8 text-center shadow-soft">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-rose-50 text-rose-600"><AlertTriangle size={24} /></div>
          <h2 className="font-display text-lg font-semibold">{title}</h2>
          <p className="mt-2 text-sm text-muted-foreground">{hint}</p>
          <p className="mt-3 rounded-lg bg-muted px-3 py-2 text-left font-mono text-[11px] text-muted-foreground break-all" data-testid="error-boundary-detail">{String(this.state.error?.message || this.state.error).slice(0, 300)}</p>
          <div className="mt-5 flex justify-center gap-2">
            <Button variant="outline" className="rounded-xl" onClick={() => (onRetry ? (this.setState({ error: null }), onRetry()) : window.location.reload())} data-testid="error-boundary-retry"><RefreshCw size={14} className="mr-1.5" />Muat ulang</Button>
            <Button className="rounded-xl" onClick={() => { window.location.href = backHref; }} data-testid="error-boundary-back">Kembali</Button>
          </div>
        </div>
      </div>
    );
  }
}
